import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { DialogState } from '../models/DialogState';

export const REMOVE_COMMENT = 'REMOVE_COMMENT';

export class RemoveCommentAction implements IDialogAction {
    public readonly type = REMOVE_COMMENT;
    public constructor(public payload: any, private _service?: DialogSignalRService) { }
    public middleware(): any {
        if (this._service) {
            this._service.deleteComment(this.payload.ids);
        }
        return;
    }
    public reducer(state: DialogState): DialogState {
        if (this.payload.ids.length > 2) {
            state.feed.messages.filter(m => +m.id === +this.payload.ids[0]).forEach(m => {
                m.comments.filter(c => +c.id === +this.payload.ids[1]).forEach(c => {
                    if (m.comments)
                        c.comments.splice(c.comments.findIndex(ic => +ic.id === +this.payload.ids[2]), 1);
                });
            });
        }
        else if (this.payload.ids.length > 1) {
            state.feed.messages.filter(m => +m.id === +this.payload.ids[0]).forEach(m => {
                if (m.comments)
                    m.comments.splice(m.comments.findIndex(c => +c.id === +this.payload.ids[1]), 1);
            });
        }
        return state;
    }
}

export const RemoveCommentActionTypeMapping = {
    [REMOVE_COMMENT]: RemoveCommentAction
};